<template>
  <div>
    <zt-modal :active="isModalVisible" persistent title="Ingresar email">
      <template>
        <div class="flex px-8 py-16">
          <div class="warning-icon mr-10 info-icon flex justify-start items-start">
            <zt-icon name="exclamation-circle-outline" />
          </div>
          <div class="items-center mr-12">
            <p class="text-zt-lg">
              {{ $t('message.publishDocuments.onlyPublish.addEmail', {
                userName
              })
              }}
            </p>
            <div class="mt-8 mb-1">
              <zt-input
                v-model="email"
                v-validate="'required|email'"
                data-vv-name="email"
                outlined
                :label="$t('message.publishDocuments.onlyPublish.enterEmail')"
              />
              <div
                class="text-base text-zt-danger my-3 md:my-3"
                v-show="errors.has('email')"
              >
                <span v-show="errors.has('email')" class="help is-danger">{{
                  errors.first("email")
                }}</span>
              </div>
            </div>
            <div class="mt-8">
              <button
                class="underline ...
                  background-transparent
                  text-base
                  text-gray-50
                "
                @click="$emit('close-modal')"
              >
                {{ $t('message.publishDocuments.onlyPublish.haveNoEmail') }}
              </button>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <div
          class="
            zt-modal-footer
            flex
            justify-end
            lg:justify-end
            items-center
            p-4
          "
          style="background-color: #eeeeee !important"
        >
          <button text class="mr-6 text-gray-700" @click="$emit('close-modal')">
            {{ $t('message.publishDocuments.onlyPublish.cancel') }}
          </button>
          <zt-button
            :disabled="errors.any()"
            class="ml-1"
            v-on:click="$emit('send-notification', email)"
            >{{ $t('message.publishDocuments.onlyPublish.confirm') }}</zt-button
          >
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    userName: String,
  },
  data() {
    return {
      modalViewState: false,
      email: "",
    };
  },
  computed: {
    isModalVisible: {
      get() {
        return this.modalViewState;
      },
      set(value) {
        this.modalViewState = value;
      },
    },
  },
  watch: {
    value(newVal) {
      this.modalViewState = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.btnCancelar {
  color: #585757 !important;
}
.info-icon {
  font-size: 5rem !important;
  color: #fb8c00;
}
</style>
